import { styled } from '@mui/material/styles';
import { Autocomplete, TextField, Typography, Paper, Popper } from '@mui/material';

// Autocomplete Styles
export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E0E0E0',
    },
    '&:hover fieldset': {
      borderColor: '#BDBDBD',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00A67E',
    },
  },
}));

export const StyledPopper = styled(Popper)`
  .MuiAutocomplete-listbox {
    & > li {
      border-bottom: 1px solid #e0e0e0;
      margin: 6px;
    }
  }
`;

// TextField Styles
export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: '#757575',
    '&.Mui-focused': {
      color: '#00A67E',
    },
  },
  "& .MuiAutocomplete-input": {
    padding: "0px 0px 4px 0px !important"
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',

  },
  '& .MuiOutlinedInput-root': {
    height: '34px',
  },
  width: "280px",
  borderRadius: '4px',
}));

// Paper Styles for dropdown
export const StyledPaper = styled(Paper)(({ theme }) => ({
  boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
  marginTop: '4px',
  borderRadius: '4px',
  maxHeight: '400px',
  '& .MuiAutocomplete-listbox': {
    maxHeight: '350px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
}));

// Typography Styles for option labels
export const OptionLabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  color: '#1A1A1A',
}));

// Typography Styles for option descriptions
export const OptionDescriptionTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: '#757575',
  marginTop: '2px',
}));

// Typography Styles for option counts
export const OptionCountTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: '#757575',
  marginLeft: '4px',
}));

// Typography Styles for no options text
export const NoOptionsTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#757575',
  padding: theme.spacing(1),
}));